<script>
    import Icon from 'svelte-awesome'
    import Required from './Required.svelte'
    import ValidationMessage from './ValidationMessage.svelte'
    import { FormGroup, InputGroup, DropdownToggle, InputGroupButtonDropdown, Input, Label } from 'sveltestrap'
    import { createEventDispatcher } from 'svelte'
    import { spinner } from 'svelte-awesome/icons'
    import { get } from 'dot-prop'

    export let context
    export let formKey
    export let index
    export let keypath // The keypath without the formKey or index, e.g. "attributes.videos.3.url"
    export let value
    export let label
    export let placeholder
    export let required
    export let disabled
    export let helptext
    export let uploading
    export let fileUploader // function that deals with http/api calls and returns back S3 fragment

    // TODO not sure where we get this info, but will need it when we upload to private folder
    // export let schoolId = 'AKTECH'

    const emptyFragment = {
        mimeType: '',
        byteLength: 0,
        key: '',
        bucket: '',
        filename: ''
    }

    let inputElement

    $: formKeypath = index === undefined ? `${formKey}.${keypath}` : `${formKey}.${index}.${keypath}`
    $: isInvalid = get(context, `error.${formKeypath}.level`) === 'error'
    $: displayValue = get(value, 'filename')

    const dispatch = createEventDispatcher()

    const triggerFileUpload = () => {
        if (!disabled && inputElement) {
            inputElement.click()
        }
    }

    const removeFile = () => {
        value = ''
        dispatch('change', { formKey, index, keypath, value: emptyFragment, context })
    }

    const upload = async ({ target }) => {
        const file = target && target.files && target.files[0]

        if (file) {
            const reader = new FileReader()
            uploading = true
            reader.onload = async (event) => {
                file.data = event.target.result.split(',')[1]

                const fileFragment = await fileUploader({ file })

                value = fileFragment
                dispatch('change', { formKey, index, keypath, value: fileFragment, context })
                uploading = false
            }

            reader.readAsDataURL(file)
        }
    }
</script>

<style>
    :global(.input-file-append .btn) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
</style>

<FormGroup>
    <Label for={formKeypath}>
        {label || ''}
        <Required {required} />
    </Label>
    <InputGroup>
        <Input
            type="text"
            readonly
            id={formKeypath}
            name={formKeypath}
            {placeholder}
            {isInvalid}
            value={displayValue}
        />
        <InputGroupButtonDropdown
            class="input-file-append"
            addonType="append"
            isOpen={false}
            toggle={() => false}
            on:click={triggerFileUpload}
        >
            {#if displayValue}
                <DropdownToggle on:click={removeFile}>Clear</DropdownToggle>
            {:else if uploading}
                <DropdownToggle disabled>
                    <Icon class="appIconSpinner" data={spinner} spin />
                </DropdownToggle>
            {:else}
                <DropdownToggle on:click={triggerFileUpload}>Select a file...</DropdownToggle>
            {/if}
        </InputGroupButtonDropdown>
    </InputGroup>
    <ValidationMessage {context} {formKeypath} {helptext} />

    <input class="invisible" bind:this={inputElement} on:change={upload} type="file" accept=".jpg,.jpeg,.png" />
</FormGroup>
